import {
  FETCH_MESSAGE_TEMPLATES_ERROR,
  FETCH_MESSAGE_TEMPLATES_INIT,
  FETCH_MESSAGE_TEMPLATES_SUCCESS,
} from './constants';

export function fetchMessageTemplatesAction(
  templateType,
  templateVariant,
  applicantId,
  whatsAppProvider,
  page = 1,
  searchQuery = '',
) {
  return {
    type: FETCH_MESSAGE_TEMPLATES_INIT,
    templateType,
    templateVariant,
    applicantId,
    whatsAppProvider,
    page,
    searchQuery,
  };
}

export function fetchMessageTemplatesSuccessAction(
  messageTemplates,
  whatsAppTemplates,
  pagination,
  whatsAppPagination,
) {
  return {
    type: FETCH_MESSAGE_TEMPLATES_SUCCESS,
    messageTemplates,
    whatsAppTemplates,
    pagination,
    whatsAppPagination,
  };
}

export function fetchMessageTemplatesErrorAction() {
  return {
    type: FETCH_MESSAGE_TEMPLATES_ERROR,
  };
}
